import React from 'react';
import OptInEditor from '../PreferencePage/Components/OptInEditor';
import {
  URLContainer,
  EmbedCodeContainer,
  MainTitle,
  MainDescription,
  Divider,
  SectionTitle,
  IconTitleContainer,
  IconTitle,
  SectionDescription,
  FooterContainer,
  FooterNote,
  FooterLink,
  SaveButton,
  SectionDivider,
  CopyUrlSection,
  CopyUrlTitle,
  EmbedCodeTitle,
  EmbedCodeWrapper,
  EmbedCodeContent,
  OptInEditorWrapper,
} from './NonMemberSignup.styled';
import { FileCopy, Link, Code, WebAsset } from '@material-ui/icons';
import { toast } from '../../../../redux/actions/UI';
import { useDispatch } from 'react-redux';

const NonMemberSignupLeftSection = ({
  selectedOrg,
  goToPreferencePage,
  onTextChange,
  headerText,
  loading,
  isEdited,
  onHeaderSave,
}) => {
  const dispatch = useDispatch();
  const copyToClipboard = text => {
    navigator.clipboard.writeText(text);
    dispatch(toast('success', 'Copied to clipboard'));
  };

  const signupUrl = `${
    process.env.REACT_APP_webUrl
  }/nonmembersignupform?orgId=${
    selectedOrg.hashId
  }&acronym=${encodeURIComponent(selectedOrg.acronym)}`;
  const embedCode = `<iframe src="${signupUrl}" style="border: none; width: 100%; height: 100vh; min-height: 100vh; overflow: hidden;" scrolling="auto"></iframe>`;

  return (
    <>
      <MainTitle>Nonmember Signup Form</MainTitle>
      <MainDescription>
        A nonmember sign-up form lets people outside your community or
        organization join your mailing list, RSVP to an event, or sign up for
        updates. It’s a simple way to collect contact information from new
        audiences and grow your reach.
      </MainDescription>
      <Divider />
      {/* === Form Design Section === */}
      <div>
        <SectionTitle>Form Design</SectionTitle>
        <IconTitleContainer>
          <WebAsset style={{ fontSize: '18px' }} />
          <IconTitle>Welcome Header</IconTitle>
        </IconTitleContainer>
        <SectionDescription>
          This is the welcome message that appears at the top of your signup
          form. Use it to briefly introduce your community, event, or offer.
          Keep it short, friendly, and clear. Make a great first impression.
        </SectionDescription>
        <OptInEditorWrapper>
          <OptInEditor onTextChange={onTextChange} optinMessage={headerText} />
        </OptInEditorWrapper>
        {/* Footer Note + Button */}
        <FooterContainer>
          <FooterNote>
            *You can change your logo on the{' '}
            <FooterLink onClick={() => goToPreferencePage()}>
              Preference page
            </FooterLink>
          </FooterNote>
          <SaveButton
            size="small"
            variant="outlined"
            disabled={loading || !isEdited}
            onClick={() => onHeaderSave()}
          >
            {loading ? 'Saving...' : 'Save Changes'}
          </SaveButton>
        </FooterContainer>
        {/* Divider after Save Changes button */}
        <SectionDivider />
      </div>
      {/* === Share Form Section === */}
      <div>
        {/* Section heading like "Form Design" */}
        <SectionTitle>Share Form</SectionTitle>

        {/* === Copy URL Section === */}
        <CopyUrlSection>
          <IconTitleContainer>
            <Link style={{ fontSize: '18px' }} />
            <CopyUrlTitle>Copy URL</CopyUrlTitle>
          </IconTitleContainer>
          <URLContainer onClick={() => copyToClipboard(signupUrl)}>
            <span>{signupUrl}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <FileCopy style={{ fontSize: '16px', color: '#007ade' }} />
              <span style={{ fontSize: '13px', color: '#007ade' }}>Copy</span>
            </div>
          </URLContainer>
        </CopyUrlSection>

        {/* === Embed Code Section === */}
        {/* === Embed Code Section === */}
        <div>
          <IconTitleContainer>
            <Code style={{ fontSize: '18px' }} />
            <EmbedCodeTitle>Embed code</EmbedCodeTitle>
          </IconTitleContainer>
          <EmbedCodeWrapper>
            <EmbedCodeContainer onClick={() => copyToClipboard(embedCode)}>
              <EmbedCodeContent>{embedCode}</EmbedCodeContent>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
              >
                <FileCopy style={{ fontSize: '16px', color: '#007ade' }} />
                <span style={{ fontSize: '13px', color: '#007ade' }}>Copy</span>
              </div>
            </EmbedCodeContainer>
          </EmbedCodeWrapper>
        </div>
      </div>
    </>
  );
};

export default NonMemberSignupLeftSection;
